export default "__VITE_ASSET__DnrtmQ86__"